/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
/// <reference path="../../_ext/editors/grideditorbase.ts" />
namespace TabAurous.OMS {
    var x;
    @Serenity.Decorators.registerClass()
    export class ProductBOMEditor extends _Ext.BOMGridEditor<ProductBOMRow> { 
        protected getDialogType() { return ProductBOMDialog; }
        protected getLocalTextPrefix() { return ProductBOMRow.localTextPrefix; }
        protected get_ExtGridOptions() { return Q.deepClone(q.DefaultEditorGridOptions) }
          

        
        constructor(container: JQuery) { 
            super(container); 
            this.view.onDataChanged.subscribe(() => {
                if (this.view.getItems().length > 0) {
                    (this.parentDialog as OMS.ProductMasterDialog).CalculateTotals();
                    (this.parentDialog as OMS.ProductMasterDialog).recalculateLabor();
                }
            })
            //this.form.ItemTypeId.changeSelect2(e => {
            //    var item = Q.toId(this.form.ItemTypeId.value);
            //    this.setFields(item);
            //});

        }

        public DisableAddButton() {
            this.toolbar.element.hide();
            this.element.hide();
        }

        public EnableAddButton() {
            this.toolbar.element.show();
            this.element.show();
            


        } 
        
        private autoSize;

        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }

        protected getButtons() {
            let buttons = super.getButtons();
            var grid = OMS.RawMaterialMasterSelectGrid;
            // grid.apply(this.rowSelection = new Serenity.GridRowSelectionMixin(this));
            //grid.apply(this.getColumns = (Serenity.GridRowSelectionMixin.createSelectColumn(() => this.rowSelection));

            //buttons.push({
            //    title: "Pick Components",
            //    cssClass: "add-button",
            //    onClick: () => {
            //        var pickerDialog = new _Ext.GridItemPickerDialog({
            //            gridType: grid, multiple: true,
            //            preSelectedKeys: this.value.map(k => k.ProductId)
            //        });

            //        pickerDialog.onSuccess = (selectedItems: any[]) => {
            //            let selectedItems2 = selectedItems;
            //            //alert('Length' + selectedItems.length);
            //            var orddetails = [];
            //            var bomdetails = [];
            //            selectedItems2.forEach(function (value) {
            //                var prdid = value.ProductId;
            //                var atb = OMS.ProductMasterRow.getLookup().itemById[prdid].AttributeId;
            //                let ATBDetails = OMS.CommonAttributesRow.getLookup().itemById[atb]

            //                var Pieces = OMS.ProductMasterRow.getLookup().itemById[prdid].Pieces;
            //                var Weight = OMS.ProductMasterRow.getLookup().itemById[prdid].Weight;
            //                var Rate = 0;
            //                if (ATBDetails.ItemTypeId == 104)
            //                     Rate = Q.first(OMS.MetalRateMasterRow.getLookup().items, x => x.MetalTypeId == ATBDetails.ProductTypeId && x.RateTypeId == 33
            //                        && x.CompanyId == Q.Authorization.userDefinition.CompanyId).Rate;
            //                if (ATBDetails.ItemTypeId  == 105)
            //                    Rate = RateHelper.GetStoneSalesRate(atb, 0);

            //                //var Amount = OMS.ProductMasterRow.getLookup().itemById[prdid].A;

            //                var productBom: ProductBOMRow = {
            //                    BOMProductId: prdid,
            //                    ProductCode: value.ProductCode,
            //                    BOMAttributeId: value.AttributeId,
            //                    Attribute: ATBDetails.Attribute,
            //                    ItemType: ATBDetails.ItemType,
            //                    ItemTypeId: ATBDetails.ItemTypeId,
            //                    CategoryId: ATBDetails.CategoryId,
            //                    SubCategoryCode: ATBDetails.SubCategoryCode,
            //                    StoneColorId: ATBDetails.StoneColorId,
            //                    MetalColorId: ATBDetails.MetalColorId,
            //                    KaratId: ATBDetails.KaratId,
            //                    KaratCode: ATBDetails.KaratCode,
            //                    BomRate: Rate,
            //                    Pieces: Pieces,
            //                    Weight: Weight,
            //                    CalcOnId: value.CalcOnId,
            //                    ShapeId: ATBDetails.ShapeId,
            //                    QualityId: ATBDetails.QualityId,
            //                    QualityCode: ATBDetails.QualityCode,
            //                    StdPurity: value.StdPurity,
            //                    BomAmount: value.CalcOnId == 3 ? Pieces * Rate||0 : Weight * Rate ||0
            //                };
            //                orddetails.push(productBom);

            //            });
                        
            //            //alert('Length details' + orddetails.length);
            //            for (let orderDetail of orddetails) {
            //                orderDetail[this.getIdProperty()] = "`" + this.nextId++;
            //                //alert('ID ' + orderDetail.PrdId);
            //                var x = orderDetail;
            //                this.view.addItem(orderDetail);

            //            }

            //        }

            //        pickerDialog.dialogOpen();
            //    }
            //});

            return buttons;
        }
        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
        validateEntity(row: ProductBOMRow, id: number) {
            if (!super.validateEntity(row, id))
                return false;


            //duplicate Component
            //row.BOMProductId = Q.toId(row.BOMProductId);

            //var sameProduct = Q.tryFirst(this.view.getItems(), x => x.BOMProductId === row.BOMProductId);
            //if (sameProduct && this.id(sameProduct) !== id) {
            //    Q.alert('This Component is already in product details!');
            //   return false;
            //}

             //update values in grid

            //row.ProductCode = ProductMasterRow.getLookup().itemById[row.BOMProductId].ProductCode; 
            return true;
        }    
        public setData(bomvalues: ProductBOMRow[]) {

            this.view.setItems([], false);
            var tmp = [];
            for (let bom of bomvalues) {
                bom[this.getIdProperty()] = "`" + this.nextId++;
                this.view.addItem(bom);
            }
            return tmp;

        }

        protected setFields(ItemType: number) {

            switch (ItemType) {

                case 104: {
                    this.form.KaratId.getGridField().toggle(false);
                    this.form.Purity.getGridField().toggle(false);
                    this.form.MetalColorId.getGridField().toggle(false);
                    this.form.ShapeId.getGridField().toggle(true);
                    this.form.QualityId.getGridField().toggle(true);
                    this.form.StoneColorId.getGridField().toggle(true);
                    Serenity.EditorUtils.setRequired(this.form.Pieces, false);
                    break;
                    //Serenity.EditorUtils.se
                }
                case 105: {
                    this.form.KaratId.getGridField().toggle(true);
                    this.form.Purity.getGridField().toggle(true);
                    this.form.MetalColorId.getGridField().toggle(true);
                    this.form.ShapeId.getGridField().toggle(false);
                    this.form.QualityId.getGridField().toggle(false);
                    this.form.StoneColorId.getGridField().toggle(false);
                    Serenity.EditorUtils.setRequired(this.form.Pieces, true);
                    break;
                }

                default: {
                    this.form.KaratId.getGridField().toggle(true);
                    this.form.Purity.getGridField().toggle(true);
                    this.form.MetalColorId.getGridField().toggle(true);
                    this.form.ShapeId.getGridField().toggle(true);
                    this.form.QualityId.getGridField().toggle(true);
                    this.form.StoneColorId.getGridField().toggle(true);
                    Serenity.EditorUtils.setRequired(this.form.Pieces, false);
                    break;

                }

            }


        }

    }
}